import UIkit from './uikit.min.js';
import UIkitIcons from './uikit-icons.min.js';

// Expose UIkit globally for legacy scripts and register icons explicitly.
window.UIkit = UIkit;
UIkit.use(UIkitIcons);
// import './barba_2.9.7.js';
import './Drift.min.js';
import './confetti.min.js';
// import './blobshape.js';
